import { combineReducers, createSlice } from '@reduxjs/toolkit'

import InternalDealsReducer from './InternalSitesReducer'

const internalReducer = combineReducers({
  sites: InternalDealsReducer
})

export default internalReducer
